var map = {
	"./adwords.svg": "8IQW",
	"./browser.svg": "adwu",
	"./seo.svg": "n7r7",
	"./software.svg": "mG6Y",
	"./website.svg": "I/x7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Okyp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flaticon ^\.\/.*$
// module id = Okyp
// module chunks = 0